import * as moment from 'moment';


export class TimeUtility {

  constructor(){}

  convertMeridianTimeForServer(date, hour, minute, meridian) {

    if (date) {

      if( meridian === 'AM' && hour === "12"){
        hour = "00";
      }

      if(meridian === 'PM' && hour != "12"){
        hour = parseInt(hour) + 12;
      }

      return date + 'T' + hour + ':' + minute + ':00';
    }
  }

  convertMeridianTimeFromServer(date) {
    var time = [];

    const copy = date.trim().split('T');
    var formatted = moment(copy[1], "HH:mm:ss").format("hh:mm A");
    const parts = formatted.trim().split(':');
    const parts2 = parts[1].trim().split(' ');
    time.push(parts[0]);
    time.push(parts2[0]);
    time.push(parts2[1]);
    return(time);

  }

  convertTimeForServer(date, time){
    if(time.hour < 10){
      time.hour = '0' + time.hour;
    }
    if(time.minute < 10){
      time.minute = '0' + time.minute;
    }
    if(time.second < 10){
      time.second = '0' + time.second;
    }

    return date+ 'T' + time.hour + ':' + time.minute;
  }



    convertTimeFromServer(value){
      let myDateObj ={hour:'',minute:'',second:''};

      if (value) {
        let myHour = value[3];
        let myMin = value[4];
        let mySeconds = '00';
        myDateObj.hour = myHour.toString();
        myDateObj.minute = myMin.toString();
        myDateObj.second = mySeconds.toString();
      }
      return myDateObj;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/Utility/TimeUtility.ts